import styled from 'styled-components';
import { Box, Typography } from '@mui/material';
import { ILenderListItem } from '@modules/admin/Tools/shared/LenderControlsHeader';

interface LenderOptionTypographyProps {
  option: ILenderListItem;
}

interface LenderOptionsOuterGridProps {
  numColumns: number;
}

export const TabsPageHeader = styled.div`
  && {
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
	margin-top: 16px;

    .MuiTypography {
      color: ${({ theme }) => theme.palette.common.black};
    }
  }
`;

export const SelectLenderWrapper = styled.div`
  width: 200px;
  margin-right: 20px;
`;

export const LenderOptionsOuterGrid = styled(Box)<LenderOptionsOuterGridProps>`
  display: grid;
  grid-template-columns: ${({ numColumns }) => `repeat(${numColumns}, 1fr)`};
  gap: 16px;
  align-items: stretch;
  justify-content: space-between;
  min-height: 100%;
  margin-bottom: 12px;
`;

export const LenderOptionTypography = styled(Typography)<LenderOptionTypographyProps>`
  padding: 8px;
  cursor: pointer;
  border: ${({ theme }) => theme.palette.primary.main} 1px solid;
  border-radius: 8px;
  color: ${({ theme, option }) => 
    option && option.isActive 
      ? theme.palette.primary.main 
      : theme.palette.error.main};
  transition: all 0.2s ease-in-out;
  font-weight: 600;
  &:hover { 
    background-color: ${({ theme }) => theme.palette.primary.light}; 
    color: ${({ theme }) => theme.palette.common.white};
  }
`;

export const LenderSelectionDropdown = styled(Typography)<{isActive: boolean}>`
  padding: 6px 12px;
  cursor: pointer;
  font-weight: 600;
  color: ${({ theme, isActive }) => 
    isActive 
      ? theme.palette.primary.main 
      : theme.palette.error.main};
`;